import { createStore, withProps } from '@ngneat/elf';
import { withRequestsStatus } from '@ngneat/elf-requests';

import { AuditDetails } from './audits-details.model';

export const auditDetailsStore = createStore(
  {name: 'audit-details'},
  withProps<Partial<AuditDetails>>({}),
  withRequestsStatus(),
);